var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.64 9.20455C17.64 8.56636 17.5827 7.92818 17.48 7.31273H9V10.8H13.8436C13.6364 11.9182 13.0036 12.8636 12.0582 13.5V15.7636H14.9727C16.68 14.1818 17.64 11.8582 17.64 9.20455Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 18C11.43 18 13.4673 17.1968 14.9728 15.7637L12.0583 13.5C11.2551 14.04 10.2292 14.3664 9.00001 14.3664C6.65637 14.3664 4.67092 12.7846 3.96547 10.6582H0.952728V12.9928C2.45092 15.9709 5.53092 18 9.00001 18Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96545 10.6582C3.78727 10.1182 3.68545 9.54184 3.68545 8.94548C3.68545 8.34912 3.78727 7.77275 3.96545 7.23275V4.89819H0.952727C0.332727 6.13455 0 7.51455 0 8.94548C0 10.3764 0.332727 11.7564 0.952727 12.9927L3.96545 10.6582Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 3.52364C10.3455 3.52364 11.5527 3.98545 12.5127 4.89455L15.0382 2.36909C13.4636 0.901818 11.43 0 9.00001 0C5.53092 0 2.45092 2.02909 0.952728 4.89818L3.96546 7.23273C4.67092 5.10636 6.65637 3.52364 9.00001 3.52364Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.be6b572bab9acc2f11d87f99639caa8b.svg";
export { ForwardRef as ReactComponent };